const getRedirectionPath = (location) =>
  location.search && location.search.includes("return-url")
    ? location.search.substr(location.search.indexOf("/my-account/"))
    : (location.state && location.state.from && location.state.from.pathname) ||
      "/";

export default getRedirectionPath;
